import { render, staticRenderFns } from "./dataEntryEdit.vue?vue&type=template&id=98fe0f32&scoped=true"
import script from "./dataEntryEdit.vue?vue&type=script&lang=js"
export * from "./dataEntryEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98fe0f32",
  null
  
)

export default component.exports